<template>
  <div class="pages">
    <img src="/static/service/buy/banner-dt@3x.png" class="tImg" />
    <div class="b_pic_text">
      {{ $t('main.Sitemap') }}
    </div>
    <div class="content">
      <div class="box" v-for="item in tabs" :key="item.id">
        <div :class="{ 'boxBorder': item.child.length }">
          <div class="title" @click="handleClick(item)">{{ item.name }}</div>
          <div class="nav fac">
          <div
            class="navTitle"
            v-for="v in item.child"
            :key="v.id"
            @click.stop=handleClick(v)
          >
            {{ v.name }}
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";

export default {
  data() {
    return {
      tabs: [],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      },
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.getTab();
    },
    "$store.state.tabs": function() {
      this.getTab();
    }
  },
  created() {
    this.getTab();
  },
  methods: {
    getTab() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        this.tabs = JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo")));
      }
    },
    handleClick(item) {
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates[template];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .content {
    .box {
      margin-bottom: 2.5rem;
      .boxBorder {
        min-height: 8.75rem;
        border: 1px solid #e5e5e5;
      }
      .title {
        height: 3.75rem;
        line-height: 3.75rem;
        background: #f2f2f2;
        font-size: 1.875rem;
        font-family: YouSheBiaoTiHei,serif;
        color: #666666;
        padding: 0 3.75rem;
        cursor: pointer;
      }

      .nav {
        padding: 0 3.75rem;
        color: #1a1a1a;
        line-height: 5rem;

        .navTitle {
          cursor: pointer;
          margin-right: 1.5rem;
        }
      }
    }
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 3.25rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 3.25rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 3.25rem 15%;
    }
  }
}
</style>
